import SubmitButton from "@components/SubmitButton/SubmitButton";
import { getApplicationLink } from "@utilities/applicationLinkHelper";
import { useSettings } from "@utilities/context/settings";
import React, { useState } from "react";
import styles from "./ModalEMBAMergeForm.module.scss";

const ModalEMBAMergeForm = ({
  locations,
  formHeader,
  buttonText,
  errorMessage,
  redirectDelay,
  onCloseFunction,
  user,
}) => {
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { siteSettings } = useSettings();

  const handleLocationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedLocation(event.target.value);
    setError(false);
  };

  const handleSubmit = () => {
    if (!selectedLocation) {
      setError(true);
      return;
    }

    const selectedProgramme = locations.find(
      (element) => element.value === selectedLocation
    );

    if (!selectedProgramme) {
      setError(true);
      return;
    }

    setLoading(true);

    setTimeout(() => {
      const link = getApplicationLink({
        user: !!user,
        programmeApplyOnlineId: selectedProgramme.applyId,
        isSalesforceApplication: !!selectedProgramme.isSalesforceApplication,
        siteSettings,
      });

      // getApplicationLink returns the guest slug without a leading "/"
      const applyUrl =
        link && !link.startsWith("/") && !link.startsWith("http")
          ? `/${link}`
          : link;

      if (applyUrl) {
        window.location.href = applyUrl;
      }
    }, redirectDelay);
  };

  return (
    <>
      <div className={styles["modal-emba-merge-form-wrapper"]}>
        <div className={styles["modal-emba-merge-form"]}>
          <button onClick={onCloseFunction} className={styles["close-button"]}>
            &times;
          </button>
          <h2 className={styles["modal-header"]}>{formHeader}</h2>
          <div className={styles["radio-group"]}>
            {locations.map((location, index) => (
              <label key={index}>
                <input
                  type="radio"
                  name="location"
                  value={location.value}
                  onChange={handleLocationChange}
                />

                <span className={styles["radio-option-text"]}>
                  <span>
                    <strong>{location.loc}</strong>
                    {location.date && <> - <span>{location.date}</span></>}
                  </span>

                  {location.deliveryMode && (
                    <span>{location.deliveryMode}</span>
                  )}
                </span>
              </label>
            ))}
          </div>

          {error && <p className={styles["error-message"]}>{errorMessage}</p>}

          <div className={styles["divider"]}></div>

          <div className={styles["btn-and-text-wrapper"]}>
            <div onClick={!loading ? handleSubmit : undefined}>
              <SubmitButton
                loading={loading}
                id="submitButton"
                text={buttonText}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalEMBAMergeForm;